import { Blocks, GraduationCap, Mic, Megaphone, Music, Radar, ShieldCheck } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "../motion/Reveal";
import { useSite } from "../../lib/site";

const ICONS = [GraduationCap, Mic, Megaphone, Radar, ShieldCheck, Blocks, Music];

export const Money = () => {
  const { content } = useSite();
  const m = content.dinero;
  const items = Array.isArray(m.items) ? m.items : [];
  return (
    <section id="oportunidad" className="grain relative overflow-hidden bg-ink py-14 text-white sm:py-20 lg:py-24" data-testid="dinero-section">
      <div className="pointer-events-none absolute -left-40 bottom-0 h-[520px] w-[520px] rounded-full bg-leaf/15 blur-[160px]" />
      <div className="container-x relative">
        <Eyebrow>{m.eyebrow}</Eyebrow>
        <MaskLines lines={[m.title]} className="mt-4 max-w-4xl font-display text-[1.6rem] font-semibold leading-[1.05] tracking-[-0.03em] sm:text-3xl lg:text-[2.6rem]" testId="catalogo-title" />

        <div className="mt-10 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={item.name} delay={i * 0.08} className="group relative flex flex-col rounded-[1.25rem] border border-white/10 bg-white/[0.04] p-5 transition-colors duration-300 hover:border-leaf/50 hover:bg-white/[0.07]" data-testid={`solucion-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10 text-leaf transition-colors duration-300 group-hover:bg-leaf group-hover:text-ink">
                    <Icon className="h-6 w-6" />
                  </span>
                  <span className="font-mono text-xs text-leaf">0{i + 1}</span>
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold uppercase tracking-[0.04em] sm:text-2xl" data-testid={`solucion-${i}-name`}>{item.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-[#C9D0E4] sm:text-base">{item.description}</p>
                <div className="mt-5 border-t border-white/10 pt-4">
                  <p className="font-mono text-[11px] uppercase tracking-[0.1em] text-[#AEB7D3]">{item.market ? m.market_label : "Nuevo lanzamiento"}</p>
                  <p className="mt-1 font-display text-lg font-semibold text-leaf sm:text-xl" data-testid={`solucion-${i}-market`}>{item.market || "Disponible para toda la red"}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
